import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';  // Make sure to import axios
import { ToastContainer, toast } from 'react-toastify';
import ReCAPTCHA from "react-google-recaptcha";

const BoardResetPwd = () => {
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [recaptchaValidated, setRecaptchaValidated] = useState(false);
  const [successful, setSuccessful] = useState(false);
  const captchaRef = useRef(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParams.get('token');
    if (tokenFromUrl) {
      setToken(tokenFromUrl);
    }
  }, []);

  const handleRecaptchaChange = () => {
    setRecaptchaValidated(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      toast.error('The two passwords must match.');
      setSuccessful(false);
      return;
    }

    if (!recaptchaValidated) {
      toast.error('Please validate the reCAPTCHA.');
      setSuccessful(false);
      return;
    }

    // const captchaToken = await captchaRef.current.executeAsync();
    const captchaValue = captchaRef.current.getValue()
    if (!captchaValue) {
      setSuccessful(false);
      toast.error('Please validate the reCAPTCHA.');
      return;
    }

    captchaRef.current.reset();

    try {
      const response = await axios.post('https://www.smartelec.eu.org/app_back/reset_pwd_validate_token', {
        // const response = await axios.post('https://www.smartelec.eu.org/app_back/verify', {
        token,
        newPassword,
        captchaValue: captchaValue
      });

      if (response.data.success) {
        setSuccessful(true);
        setMessage("Password reset successfully.");
      } else {
        setSuccessful(false);
        setMessage("Failed to reset password.");
      }
    } catch (error) {
      setSuccessful(false);
      setMessage("An error occurred while resetting the password.");
    }
  };

  return (
    <div className="col-md-12">
      <ToastContainer />
      <div className="card card-container">
        <img
          src="./avatar_2x.png"
          alt="profile-img"
          className="profile-img-card"
        />
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="newPassword">New Password</label>
            <input
              type="password"
              className="form-control"
              name="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              className="form-control"
              name="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
            <ReCAPTCHA
              sitekey={"6Lde9VErAAAAAAzY6nJ-sT2JZetO5mxtXq_5K2xf"}
              onChange={handleRecaptchaChange}
              ref={captchaRef}
            />
          </div>

          <div className="form-group">
            <button type="submit" className="btn btn-primary btn-block">
              Change password
            </button>
          </div>
          {message && (
            <div className="form-group">
              <div
                className={
                  successful ? "alert alert-success" : "alert alert-danger"
                }
                role="alert"
              >
                {message}
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default BoardResetPwd;
